export default "__VITE_ASSET__BVqdbPxO__"